import { useLanguage } from 'context/AppContext';
import React, { FC } from 'react';
import { ButtonContainer, ActionButton, ActionBarContainer, Title } from './ActionBar.styles';

interface ActionBarProps {
  height?: number;
  addNewTag: () => void;
  removeLastTag: () => void;
  downloadStage: () => void;
  onSaveAndSubmit: () => void;
  exit: () => void;
}

const ActionBar: FC<ActionBarProps> = ({ height, addNewTag, removeLastTag, downloadStage, onSaveAndSubmit, exit }) => {
  const [language] = useLanguage();

  return (
    <ActionBarContainer height={height}>
      <Title variant="h6">{language.ReferenceImageModal.title}</Title>
      <ButtonContainer height={height}>
        <ActionButton onClick={addNewTag}>{language.ReferenceImageModal.addTag}</ActionButton>
        <ActionButton onClick={removeLastTag}>{language.ReferenceImageModal.removeTag}</ActionButton>
        <ActionButton onClick={downloadStage}>{language.ReferenceImageModal.download}</ActionButton>
        <ActionButton onClick={onSaveAndSubmit}>{language.ReferenceImageModal.saveAndSubmit}</ActionButton>
        <ActionButton onClick={exit}>{language.ReferenceImageModal.exit}</ActionButton>
      </ButtonContainer>
    </ActionBarContainer>
  );
};

export default ActionBar;
